<p-toast [style]="{marginTop: '80px'}"></p-toast>

@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<div class="pl-4 pr-4">

  <!-- ===== FILTER BAR ===== -->
  <p-fieldset legend="Quality Check" styleClass="p-fluid" [toggleable]="false">
    <div class="p-formgrid grid" [formGroup]="form1">

      <div class="p-field col-12 md:col-4">
        <span class="p-float-label">
          <p-dropdown [options]="shortTermRentals" formControlName="shortTermRentalId"
            optionLabel="propertyCode" optionValue="shortTermRentalId"
            [filter]="true" filterBy="propertyCode" [showClear]="false"
            placeholder="Select Property" appendTo="body">
          </p-dropdown>
          <label>Select Property</label>
          @for (v of validationMessages.shortTermRentalId; track v) {
            <span>
              @if (form1.get('shortTermRentalId').hasError(v.type) && form1.get('shortTermRentalId').touched) {
                <small class="p-invalid">{{v.message}}</small>
              }
            </span>
          }
        </span>
      </div>

      <div class="p-field col-12 md:col-2">
        <span class="p-float-label">
          <p-calendar formControlName="startDate" dateFormat="yy-mm-dd" appendTo="body"></p-calendar>
          <label>From Date</label>
        </span>
      </div>

      <div class="p-field col-12 md:col-2">
        <span class="p-float-label">
          <p-calendar formControlName="endDate" dateFormat="yy-mm-dd" appendTo="body"></p-calendar>
          <label>To Date</label>
        </span>
      </div>

      <div class="p-field col-12 md:col-2 flex align-items-end">
        <button pButton type="button" icon="pi pi-search" label="Run Quality Check"
          class="p-button-primary w-full"
          [disabled]="formLoading"
          (click)="onRunCheck()">
        </button>
      </div>

    </div>
  </p-fieldset>

  <!-- ===== SUMMARY CARDS ===== -->
  @if (summary) {
    <div class="grid mt-3">

      <!-- Overall Status -->
      <div class="col-12 md:col-3">
        <p-card styleClass="h-full text-center">
          <ng-template pTemplate="header">
            <div class="pt-3 pb-1 font-semibold text-600 text-sm">OVERALL STATUS</div>
          </ng-template>
          @if (summary.allAvailabilityMatch && summary.allPricesMatch) {
            <div class="flex flex-column align-items-center gap-2">
              <i class="pi pi-check-circle text-green-500" style="font-size:2.5rem"></i>
              <span class="font-bold text-green-600 text-xl">PASSED</span>
              <span class="text-500 text-sm">WIKI ≡ RU</span>
            </div>
          }
          @if (!summary.allAvailabilityMatch || !summary.allPricesMatch) {
            <div class="flex flex-column align-items-center gap-2">
              <i class="pi pi-times-circle text-red-500" style="font-size:2.5rem"></i>
              <span class="font-bold text-red-600 text-xl">FAILED</span>
              <span class="text-500 text-sm">Sync drift detected</span>
            </div>
          }
          <ng-template pTemplate="footer">
            <div class="text-400 text-xs">
              {{summary.startDate}} → {{summary.endDate}}
            </div>
          </ng-template>
        </p-card>
      </div>

      <!-- Property Info -->
      <div class="col-12 md:col-3">
        <p-card styleClass="h-full">
          <ng-template pTemplate="header">
            <div class="pt-3 pb-1 font-semibold text-600 text-sm text-center">PROPERTY</div>
          </ng-template>
          <div class="flex flex-column gap-2 text-sm">
            <div><span class="font-semibold text-600">STR ID:</span> {{summary.shortTermRentalId}}</div>
            <div><span class="font-semibold text-600">RU Property ID:</span> {{summary.ruPropertyId}}</div>
            <div><span class="font-semibold text-600">Type:</span>
              <p-tag [value]="listingTypeName(summary.listingType)"
                [severity]="summary.isHotelRoom ? 'info' : 'secondary'"
                styleClass="ml-1">
              </p-tag>
            </div>
          </div>
        </p-card>
      </div>

      <!-- Availability Summary -->
      <div class="col-12 md:col-3">
        <p-card styleClass="h-full text-center">
          <ng-template pTemplate="header">
            <div class="pt-3 pb-1 font-semibold text-600 text-sm">AVAILABILITY</div>
          </ng-template>
          <div class="flex flex-column align-items-center gap-2">
            <span class="text-4xl font-bold" [ngClass]="summary.availabilityMismatchCount === 0 ? 'text-green-600' : 'text-red-600'">
              {{summary.availabilityMismatchCount}}
            </span>
            <span class="text-500 text-sm">mismatch{{summary.availabilityMismatchCount === 1 ? '' : 'es'}} out of {{summary.daysChecked}} days</span>
          </div>
          <ng-template pTemplate="footer">
            @if (summary.allAvailabilityMatch) {
              <span class="text-green-600 text-xs"><i class="pi pi-check mr-1"></i>All days in sync</span>
            }
            @if (!summary.allAvailabilityMatch) {
              <span class="text-red-600 text-xs"><i class="pi pi-exclamation-triangle mr-1"></i>Drift detected</span>
            }
          </ng-template>
        </p-card>
      </div>

      <!-- Pricing Summary -->
      <div class="col-12 md:col-3">
        <p-card styleClass="h-full text-center">
          <ng-template pTemplate="header">
            <div class="pt-3 pb-1 font-semibold text-600 text-sm">LOS PRICING</div>
          </ng-template>
          <div class="flex flex-column align-items-center gap-2">
            <span class="text-4xl font-bold" [ngClass]="summary.priceMismatchCount === 0 ? 'text-green-600' : 'text-red-600'">
              {{summary.priceMismatchCount}}
            </span>
            <span class="text-500 text-sm">mismatch{{summary.priceMismatchCount === 1 ? '' : 'es'}} out of {{summary.nightsChecked}} LOS slots</span>
          </div>
          <ng-template pTemplate="footer">
            @if (summary.allPricesMatch) {
              <span class="text-green-600 text-xs"><i class="pi pi-check mr-1"></i>All rates in sync</span>
            }
            @if (!summary.allPricesMatch) {
              <span class="text-red-600 text-xs"><i class="pi pi-exclamation-triangle mr-1"></i>Rate drift &gt;5%</span>
            }
          </ng-template>
        </p-card>
      </div>

    </div><!-- /grid -->

    <!-- ===== DAY-BY-DAY TABS ===== -->
    <p-tabView styleClass="mt-4">

      <!-- TAB 1: AVAILABILITY -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span>
            <i class="pi pi-calendar mr-2"></i>Availability Day-by-Day
            @if (availabilityMismatches.length > 0) {
              <p-badge [value]="availabilityMismatches.length" severity="danger" styleClass="ml-2"></p-badge>
            }
          </span>
        </ng-template>

        <!-- Filter toggle -->
        <div class="flex align-items-center gap-3 mb-3 mt-1">
          <p-inputSwitch [(ngModel)]="showOnlyAvailMismatches"></p-inputSwitch>
          <span class="text-sm text-600">Show mismatches only</span>
          <span class="text-400 text-xs ml-2">
            Showing {{filteredAvail.length}} of {{dailyAvailability.length}} days
          </span>
        </div>

        <p-table [value]="filteredAvail" [scrollable]="true" scrollHeight="480px"
          [paginator]="true" [rows]="60" [rowsPerPageOptions]="[30,60,90]"
          styleClass="p-datatable-sm p-datatable-gridlines">
          <ng-template pTemplate="header">
            <tr>
              <th style="min-width:120px" pSortableColumn="date">Date <p-sortIcon field="date"></p-sortIcon></th>
              <th style="min-width:130px" class="text-center">WIKI</th>
              <th style="min-width:130px" class="text-center">Rentals United</th>
              <th style="min-width:100px" class="text-center">Match?</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [ngClass]="availRowClass(row)">
              <td class="font-mono text-sm">{{row.date}}</td>
              <td class="text-center">
                @if (row.wikiAvailable === 1) {
                  <p-tag value="Available" severity="success"></p-tag>
                }
                @if (row.wikiAvailable === 0) {
                  <p-tag value="Blocked" severity="danger"></p-tag>
                }
                @if (row.wikiAvailable === null || row.wikiAvailable === undefined) {
                  <p-tag value="No Data" severity="warning"></p-tag>
                }
              </td>
              <td class="text-center">
                @if (row.ruAvailable === 1) {
                  <p-tag value="Available" severity="success"></p-tag>
                }
                @if (row.ruAvailable === 0) {
                  <p-tag value="Blocked" severity="danger"></p-tag>
                }
                @if (row.ruAvailable === null || row.ruAvailable === undefined) {
                  <p-tag value="No Data" severity="warning"></p-tag>
                }
              </td>
              <td class="text-center">
                @if (row.match) {
                  <i class="pi pi-check-circle text-green-500" title="In sync"></i>
                }
                @if (!row.match) {
                  <i class="pi pi-times-circle text-red-500" title="Mismatch"></i>
                }
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr><td colspan="4" class="text-center text-500 py-4">No availability data. Run the quality check first.</td></tr>
          </ng-template>
        </p-table>
      </p-tabPanel>

      <!-- TAB 2: PRICING MATRIX -->
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span>
            <i class="pi pi-dollar mr-2"></i>LOS Pricing Day-by-Day
            @if (priceMismatches.length > 0) {
              <p-badge [value]="priceMismatches.length" severity="danger" styleClass="ml-2"></p-badge>
            }
          </span>
        </ng-template>

        <!-- Legend + filter -->
        <div class="flex align-items-center flex-wrap gap-3 mb-3 mt-1">
          <div class="flex align-items-center gap-2">
            <p-inputSwitch [(ngModel)]="showOnlyPriceMismatches"></p-inputSwitch>
            <span class="text-sm text-600">Show days with mismatches only</span>
          </div>
          <div class="flex align-items-center gap-3 ml-3">
            <span class="legend-chip legend-ok">Match (≤5%)</span>
            <span class="legend-chip legend-bad">Mismatch (&gt;5%)</span>
            <span class="legend-chip legend-miss">RU Missing</span>
          </div>
          <span class="text-400 text-xs ml-auto">
            {{filteredPricing.length}} of {{dailyPricing.length}} days · W = WIKI · R = RU
          </span>
        </div>

        <div class="qc-pricing-scroll">
          <table class="qc-matrix">
            <thead>
              <tr>
                <th class="col-date">Date</th>
                <th class="col-avail">WIKI Avail</th>
                @for (n of nightRange; track n) {
                  <th class="col-night">{{n}} Night{{n > 1 ? 's' : ''}}</th>
                }
              </tr>
            </thead>
            <tbody>
              @if (filteredPricing.length === 0) {
                <tr>
                  <td [attr.colspan]="9" class="text-center text-500 py-4">
                    No pricing data. Run the quality check first.
                  </td>
                </tr>
              }
              @for (row of filteredPricing; track row.date) {
                <tr>
                  <td class="col-date font-mono text-xs">{{row.date}}</td>
                  <td class="col-avail text-center">
                    @if (row.wikiAvailable) {
                      <span class="avail-dot avail-yes" title="Available"></span>
                    }
                    @if (!row.wikiAvailable) {
                      <span class="avail-dot avail-no" title="Blocked"></span>
                    }
                  </td>
                  @for (n of nightRange; track n) {
                    <td [ngClass]="priceCellClass(row.date, n)" class="col-night">
                      @if (getNightData(row.date, n); as nd) {
                        <div class="rate-wiki">W: {{nd.wikiRate | currency:'USD':'symbol':'1.0-0'}}</div>
                        @if (nd.ruRate !== null && nd.ruRate !== undefined) {
                          <div class="rate-ru">R: {{nd.ruRate | currency:'USD':'symbol':'1.0-0'}}</div>
                          <div [ngClass]="diffClass(nd.diffPct)" class="rate-diff">
                            {{nd.diffPct !== null ? (nd.diffPct | number:'1.1-1') + '%' : '—'}}
                          </div>
                        }
                        @if (nd.ruRate === null || nd.ruRate === undefined) {
                          <div class="rate-ru text-orange-500">R: —</div>
                          <div class="rate-diff text-orange-500">missing</div>
                        }
                      }
                      @if (!getNightData(row.date, n)) {
                        <span class="text-300">—</span>
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div><!-- /pricing-scroll -->

      </p-tabPanel>

    </p-tabView><!-- /tabView -->
  } <!-- /if summary -->

</div>
